<template>
  <div
    class="organisations-page container"
    v-if="visibleOrganisations"
    :class="{ updating: saveInProgress }"
  >
    <CreateOrganisationDialog ref="createOrganisationDialog"> </CreateOrganisationDialog>
    <div class="row">
      <div class="col-sm-offset-2 col-sm-8">
        <h1>Organisations</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-offset-2 col-sm-8 text-right">
        <button class="btn btn-primary btn-sm" @click="createOrganisation" type="button">
          Create a new organisation
        </button>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-sm-offset-2 col-sm-8" :key="visibleOrganisations.length">
        <table
          class="table table-hover"
          v-data-table="
            visibleOrganisations.length && {
              paging: false,
              searching: true,
              info: true,
              columnDefs: [{ targets: 2, orderable: false }],
              order: [[0, 'asc']],
            }
          "
        >
          <thead>
            <tr>
              <th>Name</th>
              <th>Date created</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="org in visibleOrganisations" :key="org.id">
              <td>
                <a :href="'/organisation/details/' + org.id" data-test="org-name">{{ org.name }}</a>
              </td>
              <td>{{ formatDate(org.dateCreated) }}</td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import axios from "axios";
import moment from "dayjs";
import { debug as d } from "debug";
import { computed, onMounted, ref } from "vue";
import { OrganisationAndMembersApiModel, OrganisationDescriptionApiModel } from "../../api-models";
import CreateOrganisationDialog from "../../components/admin/organisation/create-organisation-dialog.vue";

const debug = d("cs.OrganisationsPage");

const visibleOrganisations = ref<OrganisationDescriptionApiModel[]>([]);

const saveInProgress = ref(false);

const canMoveOrganisations = computed(() => {
  return !!visibleOrganisations.value && visibleOrganisations.value.length > 1;
});

function formatDate(dateString: string): string | null {
  return dateString ? moment(dateString).format("DD/MM/YYYY") : null;
}

async function loadModel() {
  debug("loadModel started");
  visibleOrganisations.value = [];
  saveInProgress.value = true;
  visibleOrganisations.value = (await axios.get("/api/organisation")).data;
  saveInProgress.value = false;
  debug("loadModel finished");
}

onMounted(async () => {
  debug("Mounted");
  await loadModel();
});

const createOrganisationDialog = ref();

function createOrganisation() {
  createOrganisationDialog.value
    .open(visibleOrganisations.value)
    .then((result) => {
      if (result) {
        const newOrganisationModel = result as OrganisationAndMembersApiModel;
        window.location.href = `/organisation/details/${newOrganisationModel.id}`;
        loadModel();
      }
    })
    .finally(() => {
      createOrganisationDialog.value.close();
    });
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.organisation-details.updating {
  opacity: 0.5;
  cursor: wait;

  & > * {
    user-select: none;
    pointer-events: none;
  }
}

.renaming-container {
  input {
    max-width: 580px;
    width: 580px;
  }
}
.renaming-buttons {
  display: inline-block;
  margin-left: 10px;

  button {
    margin-left: 10px;
  }
}

.nav-column {
  border-right: 1px solid lightgray;
}

.tab-pane table td {
  line-height: 2;
}

.dropdown-menu {
  // Position to the left to ensure visibility on mobile
  right: 0;
  left: unset;
}
</style>
